import { type Auth0Client, createAuth0Client } from "@auth0/auth0-spa-js";

export interface SsoConfig {
  readonly domain: string;
  readonly clientId: string;
  /** Must match the app's login client, since the SDK's cache is keyed by audience. */
  readonly audience: string;
}

let client: Promise<Auth0Client> | undefined;

// The login flow stays in the app; this client only reads, refreshes, and ends the
// session the app's login stored in the SDK's localStorage cache.
const ssoClient = (config: SsoConfig): Promise<Auth0Client> => {
  client ??= createAuth0Client({
    domain: config.domain,
    clientId: config.clientId,
    authorizationParams: { audience: config.audience },
    cacheLocation: "localstorage",
    useRefreshTokens: true,
  });
  return client;
};

export const getSsoAccessToken = async (config: SsoConfig): Promise<string> =>
  (await ssoClient(config)).getTokenSilently();

export const revokeSsoRefreshToken = async (config: SsoConfig): Promise<void> =>
  (await ssoClient(config)).revokeRefreshToken();

/** Ends the Auth0 login session; the browser leaves the app and comes back to returnTo. */
export const logOutOfSso = async (
  config: SsoConfig,
  returnTo: string,
): Promise<void> =>
  (await ssoClient(config)).logout({ logoutParams: { returnTo } });
